// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__J2jzc","footer":"ModalUpdate_footer__2bd5u"};